import PropTypes from 'prop-types';
import React from 'react';
import { lookerParams } from '../../../../../shared/lookerParams';
import OutputTab from '../OutputTab';

RevenueByPayor.propTypes = {
    activeTab: PropTypes.string,
    onLoadComplete: PropTypes.func,
};

function RevenueByPayor(props) {
    return (
        <OutputTab
            activeTab={props.activeTab}
            lookerTemplates={lookerParams.lookerPath.revenueByPayorMixTab}
            onLoadComplete={props.onLoadComplete}
            tabLabel="RevenueByPayor"
            includeChart
        />
    );
}

export default RevenueByPayor;
